<template>
  <div class="add-team-member-container mb-4" @mousedown="focus">
    <div class="d-flex flex-wrap">
      <div
        v-for="email in addMembers"
        :key="email"
        class="add-team-member-preview flex-shrink-0"
        @mousedown.stop
      >
        {{ email }}
        <v-btn
          variant="plain"
          size="small"
          icon="mds:close"
          @click="addMembers = addMembers.filter(it => it !== email)"
          :disabled="$store.state.isWorkflowDisabled"
        />
      </div>
    </div>
    <v-text-field
      v-model="email"
      ref="textField"
      variant="solo"
      class="add-team-member-field"
      placeholder="Add people by email, comma separated"
      single-line
      hide-details
      clear-icon="mds:close"
      clearable
      @mousedown.stop
      @blur="refreshAddTeamMember"
      @keydown.enter="refreshAddTeamMember"
      :disabled="$store.state.isWorkflowDisabled"
    />
  </div>
</template>

<script>
import SES from '@/ses'
import { mapActions, mapGetters, mapState } from 'vuex'
import { validateEmail } from '@/utils/validate'
import store from '@/store'

export default {
  props: {
    modelValue: Array
  },
  data () {
    return {
      email: '',
      addMembers: [],
      rules: {
        required: value => !!value || 'Required.',
        email: (value) => {
          return validateEmail(value) || 'Invalid e-mail.'
        }
      },
      valid: true
    }
  },

  computed: {
    ...mapGetters({
      project: 'projectMemberships/activeProject'
    }),
    ...mapState({
      currentUser: state => state.user.user
    })
  },

  methods: {
    ...mapActions({
      createTeamMember: 'teamMembers/createTeamMember'
    }),
    focus ($event) {
      this.$refs.textField?.focus()
      if ($event) {
        $event.stopPropagation()
        $event.preventDefault()
      }
    },
    refreshAddTeamMember () {
      if (!this.email) {
        this.email = ''
        return
      }
      const emails = this.email.split(',')
      const invalidEmails = []
      emails.forEach(it => {
        if (validateEmail(it.trim())) {
          this.addMembers.push(it.trim())
        } else {
          invalidEmails.push(it)
        }
      })

      this.email = invalidEmails.join(',')
    },
    async inviteTeamMembers () {
      this.addMembers.forEach(async email => {
        const res = await this.createTeamMember({ email, projectId: this.$route.params.projectId })
        if (res) {
          try {
            const emailService = new SES()
            await emailService.sendEmail(
              email,
              this.project,
              this.currentUser.firstname + ' ' + this.currentUser.lastname
            )
            store.commit('snackbar/showMessage', { content: 'Invitation has been sent' }, { root: true })
          } catch (e) {
            console.log(e)
            store.commit('snackbar/showMessage', { content: 'Could not send email', timeout: 6000, color: 'red' }, { root: true })
          }
        }
      })
      this.addMembers = []
    },
    updateInvites () {
      const invites = [...this.addMembers]
      if (typeof this.email === 'string') {
        const emails = this.email.split(',')
        emails.forEach(it => {
          const email = it.trim()
          if (validateEmail(email)) {
            invites.push(email)
          }
        })
      }
      this.$emit('update:modelValue', invites)
      return invites.length
    }
  },
  watch: {
    addMembers: {
      handler () {
        this.updateInvites()
      },
      deep: true
    }
  }
}
</script>

<style>
.add-team-member-field {
  min-height: 14px !important;
  max-height: 14px !important;
  height: 14px !important;
  margin-right: -12px;
}

.add-team-member-field .v-field.v-field--variant-solo {
  background-color: transparent;
  box-shadow: none !important;
}

.add-team-member-field .v-field__input {
  padding: 0 !important;
  min-height: 16px !important;
  height: 16px !important;
  font-size: 14px !important;
  line-height: 16px !important;
}
</style>

<style scoped>
.add-team-member-container {
  cursor: text;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 52px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #CFD3D9;
}

.add-team-member-preview {
  padding: 6px;
  border-radius: 4px;
  margin-bottom: 8px;
  margin-right: 8px;
  border: 1px solid #CFD3D9;
}

.access-level-select-container span {
  margin: 0 5px;
}

.access-level-select :deep(fieldset) {
  border-style: none;
}

.hidden {
  display: none;
}
</style>
